import React from 'react';

import { P } from '../P/P';

import { Section } from './Section';
import { H2 } from './H2';
import { UL } from './UL';
import { LI } from './LI';

export const LE4 = () => (
  <Section>

    <P gapAfter>
      In dieser Lerneinheit beschäftigen sich die SuS mit verschiedenen Möglichkeiten, wie sie als Verbraucher mit Mode verträglicher umgehen können, sei es in der Anschaffung als auch in der weiteren Verwertung. Ziel ist, die SuS handlungsfähig zu machen, als Konsument verantwortungsvoll und nachhaltig zu handeln.
    </P>

    <P gapAfter>
      Definition:<br />
      Von Fair Fashion oder auch von Green Fashion, Eco Fashion, Ethical Fashion oder Sustainable Fashion spricht man, wenn die Kleidung aus umweltfreundlichen Materialien sowie unter Berücksichtigung sozialer Aspekte produziert wird.<br />
      (Quelle: Wikipedia)
    </P>

    <H2>Unterrichtsimpulse:</H2>

    <UL>
      <LI>
        Lassen Sie Ihre SuS Vorschläge zu alternativem Handeln in Bezug auf Beschaffung und Verwertung sammeln.
        In Interessengruppen (alternativ: Erarbeitung im Klassenverband) arbeiten die SuS dann Hintergrundinformationen
        zu einzelnen Aspekten heraus und bereiten konkrete Handlungsvorschläge als <b>Aufklärungskampagne</b> auf:
        als kurzer Text, als Plakat, Wandzeitung, Comic, YouTube-Film, Foto-Tutorial etc. Hierzu können die SuS das Arbeitsblatt
        nutzen. Die konkreten Vorschläge können von den SuS dann über eigene oder schulbezogene Social-Media-Kanäle verbreitet werden.
      </LI>
    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE4.js